import React from 'react';
import styles from './Workspace.module.css';

const Workspace = ({
    children,
    className = '',
    padding = 'default',
    background = 'default',
    scrollable = true,
    maxWidth,
    centered = true
}) => {
    const getPadding = () => {
        switch (padding) {
            case 'none':
                return '0';
            case 'sm':
                return 'var(--spacing-sm)';
            case 'md':
                return 'var(--spacing-md)';
            case 'lg':
                return 'var(--spacing-lg)';
            case 'xl':
                return 'var(--spacing-xl)';
            default:
                return 'var(--spacing-md)';
        }
    };

    const getBackground = () => {
        switch (background) {
            case 'light':
                return 'var(--color-background-secondary)';
            case 'dark':
                return 'var(--color-background-dark)';
            case 'transparent':
                return 'transparent';
            default:
                return 'var(--color-background)';
        }
    };

    return (
        <main
            className={`${styles.workspace} ${scrollable ? styles.scrollable : ''} ${className}`}
            style={{
                padding: centered ? '0' : getPadding(), // Padding handled by content div if centered
                position: 'relative', // Added for correct absolute positioning of children
                backgroundColor: getBackground(),
                maxWidth: maxWidth || '100%'
            }}
            role="main"
        >
            {centered ? (
                <div className={styles.content}>
                    {children}
                </div>
            ) : (
                children
            )}
        </main>
    );
};

export default Workspace;
